module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/slider_arrow_r-599e301efab9e281c5c7880dc8e99b1d.svg";